import styled from 'styled-components'
import { color } from '../../../GlobalStyle'
import { light } from '../../../themes/themes'

export const ContainerNav = styled.div``

export const ContainerInitial = styled.div`
  position: fixed;
  z-index: 5;
  width: 100%;
  left: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 4px 2vw;
  background-color: ${({ theme }) => theme.background};
  -webkit-box-shadow: 0 0 20px rgb(89 102 122 / 10%);
  box-shadow: 0 0 20px rgb(89 102 122 / 10%);
  font-size: 13px;

  .checked {
    background: #f8f8f8;
  }
`
export const ButtonFunction = styled.button`
  cursor: pointer;
  color: ${({ theme }) => theme.primary};
  margin-right: ${(props) => (props.menu ? 'auto' : '5px')};
  display: ${(props) => (props.menu ? 'flex' : null)};
  padding: 4px;
  font-size: 22px;
  .iconFunc {
    font-size: 20px;
    display: flex;
    align-items: center;
    padding: 1px;
    margin: 0 auto;
  }
`
export const ButtonToggle = styled(ButtonFunction)`
  border-radius: 50%;

  background: #2b2b2b;
  border: 1px solid rgba(0, 0, 0, 0.4);
  .moon {
    color: #666;
  }
  transition: 1s;
`

export const Logo = styled.img`
  width: 35px;
  margin-right: 1vw;
`
export const ProfileImage = styled.img`
  width: 30px;
  border-radius: 10px;
`
export const AccountTitle = styled.p`
  font-family: 'Roboto';
  color: ${({ theme }) => (theme == light ? 'rgba(43, 43, 43, 0.7)' : theme.primary)};
  font-size: 10px;
`
export const Title = styled.p`
  font-weight: bold;
`

export const ListItems = styled.ul`
  list-style-type: none;
  padding: 5px;
`

export const TitleConfig = styled.p`
  font-size: 15px;
  padding: 5px;
  font-weight: 600;
  border-bottom: 1px solid ${color.brand};
`

export const Item = styled.li`
  display: flex;
  cursor: pointer;
  font-weight: 600;
  align-items: center;
  padding: 5px;
  svg {
    margin-right: 10px;
    font-size: 20px;
  }
`

export const ProfileDiv = styled.div`
    margin-left:12px;

   
    }
`

export const Config = styled.div`
  background: #fff;
  display: ${(props) => (props.over === 'config' ? 'block' : 'none')};
  -webkit-box-shadow: 0 0 40px rgb(8 21 66 / 15%);
  box-shadow: 0 0 40px rgb(8 21 66 / 15%);
  position: absolute;
  top: 33px;
  right: 150px;
  width: 200px;
  border-radius: 5px;
  display: none;

  &:hover {
    display: block;
  }
`
